import React, { useState } from 'react';
import FormError from '../../../FormError';
import { apiFetch, errorText } from '../shared/api';
import Spinner from '../shared/Spinner';
import { formatDisplayDateTime } from './format';

export default function NotesCard({ demo, endpoints, limits, timezone = 'UTC', onNoteAdded, onToast }) {
    const [text, setText] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [textError, setTextError] = useState(null);
    const notes = demo.notes || [];

    const handleSubmit = async () => {
        setSubmitting(true);
        setTextError(null);

        try {
            const { status, json } = await apiFetch(endpoints.notes, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ text }),
            });

            if (status >= 200 && status < 300) {
                onNoteAdded(json.data);
                setText('');
                onToast({ type: 'success', text: __('Note saved') });
            } else if (status === 422) {
                setTextError(json?.errors?.text?.[0] || null);
                onToast({ type: 'error', text: __('Please check the form and try again.') });
            } else {
                onToast({ type: 'error', text: errorText(json, __('Something went wrong. Please try again.')) });
            }
        } catch (error) {
            console.error(error);
            onToast({ type: 'error', text: __('Something went wrong. Please try again.') });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="card" data-testid="demo-edit-notes">
            <div className="card-body">
                <ul className="list-unstyled">
                    {notes.map((note) => (
                        <li key={note.id}>
                            <strong>{note.author?.name}</strong>
                            {' '}
                            <small className="text-muted">{formatDisplayDateTime(note.created_at, timezone)}</small>
                            <p>{note.text}</p>
                        </li>
                    ))}
                </ul>

                <div className="form-group">
                    <label htmlFor="demo-edit-notes-field">
                        {__('Notes')} <span className="demo-island-optional">{__('(optional)')}</span>
                    </label>
                    <textarea
                        id="demo-edit-notes-field"
                        className="form-control"
                        placeholder={__('Add any notes about this demo account...')}
                        maxLength={limits.note}
                        value={text}
                        onChange={(event) => setText(event.target.value)}
                    />
                    <small className="form-text text-muted text-right d-block">{`${text.length}/${limits.note}`}</small>
                    <FormError error_message={textError} />
                </div>

                <span className={`demo-island-btn-guard${submitting || !text.trim() ? ' is-disabled' : ''}`}>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        disabled={submitting || !text.trim()}
                        onClick={handleSubmit}
                    >
                        {submitting
                            ? <Spinner label={__('Saving')} className="mr-2" />
                            : <i className="fas fa-save mr-2" aria-hidden="true" />}
                        {__('Save Notes')}
                    </button>
                </span>
            </div>
        </div>
    );
}
